import { render, staticRenderFns } from "./RequestDetailBasicDetails.vue?vue&type=template&id=b218bfe6"
import script from "./RequestDetailBasicDetails.vue?vue&type=script&lang=js"
export * from "./RequestDetailBasicDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports